import React, { PureComponent } from 'react';
import _ from 'lodash'
import {
  Card, CardBody, Col, Button, ButtonToolbar, Container, Row, Table, Modal
} from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import './styles.css';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { MDBDataTable } from 'mdbreact';

import API from '../../../Common/api';

import './styles.css';
import LoadingOverlay from 'react-loading-overlay';

import DarkBackground from '../../../Common/backgroundLoader';
import exportToCSV from '../../../Common/exportcsv';
import Overlay from '../../../Common/overlay';
import DownloadIcon from '../../../../images/download_icon.svg'


var url = window.location.hostname;
var port = window.location.port;

class HorizontalForm extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
  };

  constructor() {
    super();

    this.state = {
      loading_overlay: false,
      data: [],
      cols: [],
      showFetchBinData: false,
      orderData: [],

    };
  }

  showPassword = (e) => {
    e.preventDefault();
    this.setState(prevState => ({ showPassword: !prevState.showPassword }));
  };

  componentDidMount() {
  }

  componentWillMount() {

    if (window.location.port == 8091 || window.location.port === ":8090") {
      port = ":8090"
    } else if (window.location.port == 8098 || window.location.port === ":8098") {
      port = ":8099";
    } else {
      port = ":8088"
    }

    if (url === "localhost") {
      url = "15.206.34.41" + ":8088";

    } else {
      url = window.location.hostname + port;
    }

  }

  fetchTilesdata = async () => {
    this.setState({
      loading: true
      // selectedTile: `${step} (${category})`,
      // isTileDisabled: true      // <-- disable tiles when API starts
    });

    try {
      const { data } = await API.get(
        `/reports/bin-wise-expiry`
      );

      const tileData = data || [];
      console.log("tileData", tileData)

      const columns =
        tileData.length > 0
          ? Object.keys(tileData[0]).map((k) => ({
            label: k,
            field: k,
            width: 220,
            sort: "disabled",
          }))
          : [];

      this.setState({
        tile_data: tileData,
        mdbTable: { columns, rows: tileData },
        loading: false,
        showFetchBinData: true,
        isTileDisabled: false    // <-- enable after success
      });
      console.log("mdbTable", this.state.mdbTable)

    } catch (err) {
      console.error(err);
      this.setState({ loading: false, isTileDisabled: false });  // <-- enable after failure
    }
  };
   handleDownload = () => {
    const { mdbTable, filteredRows, searchTerm } = this.state;
    
    if (!mdbTable || !mdbTable.rows || mdbTable.rows.length === 0) {
      alert('No data available to download');
      return;
    }

    // Use filtered rows if search is active, otherwise use all rows
    const rows = searchTerm ? filteredRows : mdbTable.rows;

    // Extract headers from columns
    const headers = mdbTable.columns.map(col => col.label);

    // Build CSV content
    let csvContent = headers.join(',') + '\n';
    
    rows.forEach(row => {
      const values = headers.map(header => {
        const value = row[header];
        // Handle values with commas, quotes, or newlines
        if (value === null || value === undefined) {
          return '';
        }
        const stringValue = String(value);
        if (stringValue.includes(',') || stringValue.includes('"') || stringValue.includes('\n')) {
          return `"${stringValue.replace(/"/g, '""')}"`;
        }
        return stringValue;
      });
      csvContent += values.join(',') + '\n';
    });

    // Create blob and download
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    
    link.setAttribute('href', url);
    link.setAttribute('download', `${this.state.selectedTile || 'table-data'}.csv`);
    link.style.visibility = 'hidden';
    
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };
  

  render() {

    return (
      <Col xl={12} style={{ margin: 0, padding: 0 , height:'100%'}}>
        {this.state.loading_overlay && (
          <DarkBackground disappear={this.state.loading_overlay}>

            <LoadingOverlay
              active={this.state.loading_overlay}
              // spinner={<BounceLoader />}
              spinner={this.state.loading_overlay}
              text={this.state.loadingText}
              style={{ textAlign: "center", alignItem: "center" }}
            >
              {/* <p>Some content or children or something.</p> */}
            </LoadingOverlay>
          </DarkBackground>
        )}
        <Card >
          <Overlay>
            <form className="form" >
              <div style={{ width: '100%', marginBottom: '0px', float: 'left', marginRight: 5 }}>
                <span className="filter_title">Filters</span>
              </div>

              <div className="filter_button_container" style={{ width: '100%', marginBottom: '0px', float: 'left' }}>
                <ButtonToolbar className="form__button-toolbar">
                  <Button
                    className="btn-sm button_enable1 "
                    style={{
                      fontWeight: "normal",
                      textTransform: "capitalize",
                      borderRadius: 5,
                      backgroundColor: "#70bbfd",
                      color: "#fff",
                      padding: "5px 25px",
                      fontSize: "14px",
                    }}
                    id="button_view"
                    onClick={() => this.fetchTilesdata()}
                  >
                    {this.state.loading && (
                      <i
                        className="fa fa-refresh fa-spin"
                        style={{ marginRight: "5px" }}
                      />
                    )}
                    View
                  </Button>


                  <Button
                    type="button"
                    className="btn btn-primary-outline"
                    style={{
                      cursor: this.state.btnDisabled ? 'pointer' : 'pointer',
                      backgroundColor: '#FFFFFF',
                      color: '#333333', // Set text color
                      display: 'flex',   // Use flexbox to align image and text
                      alignItems: 'center' // Center items vertically
                    }}
                    id="button_download"
                    onClick={() => this.handleDownload()}
                  >
                    <img
                      src={DownloadIcon}
                      alt="Download"
                      style={{ width: '22px' }} // Adjust size as needed
                    />
                    Download
                  </Button>
                </ButtonToolbar>
              </div>
            </form>
          </Overlay>

          {this.state.showFetchBinData && (
            <div style={{ margin: 0, padding: 0 ,width:'100%'}}>
                {/*<hr style={{marginTop:'30px',marginBottom:'0px'}}/>*/}

                <div
                  className="dispatchData stock_check_data"
                  style={{ marginTop: 0 }}
                >
                  <MDBDataTable
                  
                  striped
                  bordered
                  scrollX
                  scrollY
                  small
                  sortable={false}
                  hover
                  data={this.state.mdbTable}
                  style={{ textAlign: "left", margin: "0px", padding: "0px", paddingTop: "0px" ,width:'100%',height :'100%'}}
                  />
                </div>
              </div>

          )}

        </Card>

      </Col>
    );
  }
}

export default reduxForm({
  form: 'Upload Master', // a unique identifier for this form
})(withTranslation('common')(HorizontalForm));